import styled from '@emotion/styled';

import { Accordion } from '@/components/common/Accordion/Accordion';
import { CaptionHeadingDescription } from '@/components/common/CaptionHeadingDescription';
import { HeadingLevel } from '@/components/common/MarkUp';
import { Section } from '@/components/layout/Section';
import * as styles from '@/styles/typography';

import type { BlockWithAudience } from '@/types/shared';

import type { Faq as SanityFaq } from '@/sanity/sanity.types'

export interface FaqProps extends SanityFaq, BlockWithAudience { }

const Faq = ({
  heading,
  accordion,
  backgroundColour,
  blockSpacing,
  paddingAdjustment,
  pageAudience,
  isAudienceSwitcherEnabled,
}: FaqProps) => {
  const backgroundColourToken =
    backgroundColour?.token || '--background-subtle';

  return (
    <Section
      verticalPadding={paddingAdjustment ?? true}
      spacing={blockSpacing}
      backgroundColour={backgroundColourToken}
      className="faq"
    >
      <FaqWrapper>
        <HeadingLevel>
          <StyledCaptionHeadingDescription
            heading={heading}
            mobileAlignment="center"
            desktopAlignment="center"
          />
          <Accordion
            accordionBehaviour="allItems"
            accordionItems={accordion}
            pageAudience={pageAudience}
            isAudienceSwitcherEnabled={isAudienceSwitcherEnabled}
            isOldStyleChevron={true}
          />
        </HeadingLevel>
      </FaqWrapper>
    </Section>
  );
};

const FaqWrapper = styled.div`
  padding: var(--spacing-800) var(--spacing-250) var(--spacing-500);
  background-color: var(--surface-primary-subtle);
  border-radius: var(--radius-s);

  li:not(:last-of-type) {
    padding-bottom: var(--spacing-xx-small);
  }

  li:not(:first-of-type) {
    padding-top: var(--spacing-xx-small);
  }

  p {
    padding: 0 var(--spacing-medium) var(--spacing-medium);
    ${styles.subheadingMedium}
  }

  li span {
    padding: var(--spacing-small) var(--spacing-xx-small);
    ${styles.headingMedium}
  }
`;

const StyledCaptionHeadingDescription = styled(CaptionHeadingDescription)`
  margin-bottom: var(--spacing-xxxx-large);
`;

export { Faq };
